import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, EmptyState } from "@/components/admin/AdminPrimitives";
import { Ticket, Plus } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/cupons")({
  head: () => ({ meta: [{ title: "Cupons — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: () => (
    <div>
      <PageHeader
        title="Cupons"
        description="Códigos promocionais, descontos e campanhas."
        actions={
          <button className="inline-flex items-center gap-1.5 rounded-lg bg-[var(--navy)] px-3 py-2 text-sm font-semibold text-white hover:opacity-90">
            <Plus size={14} /> Criar cupom
          </button>
        }
      />
      <EmptyState
        icon={Ticket}
        title="Nenhum cupom cadastrado"
        description="Crie cupons percentuais ou de valor fixo, defina validade e limite de uso, e acompanhe o desempenho por campanha."
        action={
          <button className="inline-flex items-center gap-1.5 rounded-lg bg-[var(--navy)] px-4 py-2 text-sm font-semibold text-white hover:opacity-90">
            <Plus size={14} /> Criar primeiro cupom
          </button>
        }
      />
    </div>
  ),
});
